import React, { useEffect, useState } from "react";

import PCTemplate from "../../components/pc-template";
import MobileVersion from "../../components/mobile-version";
import Footer from "../../components/footer";

import { FloatButton } from "antd";

const Home: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {windowWidth > 820 ? <PCTemplate /> : <MobileVersion />}
      <Footer />

      <FloatButton.BackTop />
    </>
  );
};

export default Home;
